const COOKIE_NAME = 'rebus_player';
const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

export function getPlayer() {
  try {
    const match = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${COOKIE_NAME}=`));
    if (!match) return null;
    return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')));
  } catch {
    return null;
  }
}

export function setPlayer(data) {
  const encoded = encodeURIComponent(JSON.stringify(data));
  document.cookie = `${COOKIE_NAME}=${encoded}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
}

export function clearPlayer() {
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0`;
}
